

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {Prop} from "vue-property-decorator";

  @Component({
    name: 'LCChooser',
  })
  export default class LCChooser extends Vue {

    @Prop({default: false})
    emptyCellAvailable!: boolean;
    @Prop({default: () => []})
    disabledCellSizeIds!: number[];
    @Prop()
    availableCells!: any;
    @Prop()
    selectedId!: any;

    protected cellSizes: any[] = [
      {
        id: 3,
        image: "cell_size_3.svg",
      },
      {
        id: 2,
        image: "cell_size_2.svg",
      },
      {
        id: 4,
        image: "cell_size_4.svg",
      },
      {
        id: 5,
        image: "cell_size_4.svg", // todo: change when we will have the new design
      },
      {
        id: 1,
        image: "cell_size_1.svg",
      },
    ];
    protected selected!: number;

    protected cellCnt(id: number) {
      return this.availableCells[id] || 0;
    }
    protected cellAvailable(id: number) {
      const hasCount = this.availableCells[id];
      const isDisabled = this.disabledCellSizeIds.includes(id);
      return hasCount && !isDisabled;
    }
    protected cellSizeById(id: number) {
      return this.cellSizes.find((each) => each.id == id);
    }
    protected onCellSelected(id: number) {
      if (!this.cellAvailable(id)) {
        return;
      }
      this.$emit('selected', id);
      this.$emit('update:selected-id', id);
    }
  }

